module.exports = __webpack_public_path__ + "img/dia_textBg.9e9080c3.jpg";